import { CommonModule } from "@angular/common";
import {
  Component,
  computed,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  signal,
} from "@angular/core";
import { DialogModule } from "primeng/dialog";
import { LoaderService } from "../../../core/services/loader.service";
import { UntilDestroy } from "@ngneat/until-destroy";
@UntilDestroy()
@Component({
  selector: "jni-modal-stacker",
  templateUrl: "./modal-stacker.component.html",
  standalone: true,
  imports: [CommonModule, DialogModule],
  styleUrls: ["./modal-stacker.component.scss"],
})
export class ModalStackerComponent implements OnChanges, OnInit, OnDestroy {
  @Input() displayModal = false;
  @Input() clientId = "";
  @Input() showHeader = false;
  @Output() closeEvent = new EventEmitter();

  constructor(public _loaderService: LoaderService) {}

  element!: HTMLElement;
  private static countSignal = signal(0);

  totalInstances = computed(() => ModalStackerComponent.countSignal());

  instanceNumber!: number;

  ngOnChanges() {
    if (this.displayModal) {
      setTimeout(() => {
        this.hideImage();
      }, 3000);
    }
  }

  hideImage() {
    const resaleElement = document?.getElementById("resale");
    if (resaleElement) {
      resaleElement.style.display = "none";
    }

    const taxElement = document?.getElementById("taxexemption");
    if (taxElement) {
      taxElement.style.display = "none";
    }
  }

  closeDialog() {
    this.closeEvent.emit();
  }

  static increment() {
    ModalStackerComponent.countSignal.update(c => c + 1);
  }

  static decrement() {
    ModalStackerComponent.countSignal.update(c => c - 1);
  }

  ngOnInit() {
    this.instanceNumber = ModalStackerComponent.countSignal() + 1;
    ModalStackerComponent.increment();
  }

  ngOnDestroy() {
    ModalStackerComponent.decrement();
  }
}
